import Api from './api/ApiClient';
import * as Sentry from '@sentry/browser';

const errorBlock = document.getElementById('error');

const usernameField = document.getElementById('username');
const passwordField = document.getElementById('password');

const loginView = document.getElementById('loginView');
const loginLoadingScreen = document.getElementById('loginLoadingScreen');

const loginButton = document.getElementById('login');

function displayError(error) {
  if (error) {
    errorBlock.setAttribute('style', "");
    errorBlock.innerText = error;
  } else {
    errorBlock.setAttribute('style', "display:none;");
    errorBlock.innerText = '';
  }
}

export default async function doLoginFlow() {
  loginView.setAttribute('style', "");
  loginLoadingScreen.setAttribute('style', "display:none;");

  return await new Promise((resolve, reject) => {
    const callback = (e) => {
      e.preventDefault();

      displayError(null);

      const username = usernameField.value;
      const password = passwordField.value;

      Api
        .post('/auth/login', null, { username, password })
        .then(res => {
          if (res.error) {
            switch (res.error) {
              case 'ACCOUNT_LOCKED':
                displayError('Ihr Account wurde gesperrt. Bitte wenden Sie sich an die Verwaltung.');
                break;
              case 'INVALID_CREDENTIALS':
                displayError('Die Login Daten sind falsch.');
                break;
              default:
                displayError('Ein unbekannte Fehler ist aufgetreten.');
                break;
            }

            return;
          }

          const { sessionId, firstLogin } = res;

          loginButton.removeEventListener('click', callback);

          loginView.setAttribute('style', "display:none;");
          loginView.setAttribute('style', "");

          resolve({ sessionId, firstLogin });
        })
        .catch(err => {
          Sentry.captureException(err);

          displayError('Fehlerhafte Antwort des Login Servers.');
        });
    }

    loginButton.addEventListener('click', callback);
  });
}